import { default as CallIcon } from "assets/svgs/voitek_call";
import { useContext } from "react";
import initializeKnowlarityWidget from "./knw-widget-loader";
import { toast } from "react-toastify";
import { CALL_PROVIDERS, getCustomerPhoneNumberByPhoneType, TOAST_MESSAGE_CSS } from "modules/utilities/utility";
import _ from "lodash";
import { Tooltip } from "antd";
import { useCall } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { ActiveEngagement } from "./ShowEngagement";
import { useCallingStore } from 'modules/navbar/top/store/store';
initializeKnowlarityWidget();

const KnowlarityIntegration = (props) => {
  const { callDndFlag, provider, customerData, phoneType = "phone" } = props;
  const { activeEngagement } = useContext(ActiveEngagement);
  const { updateCallingStatus } = useCallingStore();
  const { call } = useCall();
  const { setToaster } = useToast();

  const handleCallStart = async () => {
    try {
      if (callDndFlag) {
        toast("Customer is in DND mode, Please do not call", TOAST_MESSAGE_CSS);
        return;
      }
      updateCallingStatus('knowlarityCalling', true);
      const caseId = customerData?.id;
      const engagementId = activeEngagement ?? null;

      const customerNumber = getCustomerPhoneNumberByPhoneType(customerData,phoneType);

      if (!customerNumber) return;
     const response = await call(caseId, {}, engagementId, customerNumber, setToaster, false, CALL_PROVIDERS.KNOWLARITY_V1);

      const providerName = _.get(response,["result", "provider_name"],null);
      if (providerName === CALL_PROVIDERS.KNOWLARITY_V1) {
        //Send this event for open the iframe modal
        await KNW_WIDGET.sendMessage("c2c_call");
      }
    } catch (error) {
      console.error("Error @ KNOWLARITY", error);
    }
  };

  return (
    <div
      className={`text-center ${
        callDndFlag ? "disabled-action" : "cursor-pointer"
      }`}
    >
      <Tooltip placement="bottom" title="Knowlarity">
        <div className="d-flex justify-content-center gap-2 text-wrap">
          <span
            className="button callStart"
            name="callStartButton"
            type="button"
            value="call"
            onClick={handleCallStart}
          >
            <CallIcon color="#E27c32" />
          </span>
        </div>
      </Tooltip>
    </div>
  );
};

export default KnowlarityIntegration;
